import { render, staticRenderFns } from "./vBtnReset.vue?vue&type=template&id=f06c5270&scoped=true"
import script from "./vBtnReset.vue?vue&type=script&lang=js"
export * from "./vBtnReset.vue?vue&type=script&lang=js"
import style0 from "./vBtnReset.vue?vue&type=style&index=0&id=f06c5270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06c5270",
  null
  
)

export default component.exports